import { Group, Text, Box } from "@mantine/core";
import { IconCircleCheck, IconAlertCircle } from "@tabler/icons";
import { useTranslation } from "react-i18next";
import { SFC_LICENCE_TYPES } from "../data/sfcLicences";

const SfcLicenceReadOnlyList = ({ sfcLicences, showHeading = true, ...props }) => {
  const { t } = useTranslation();

  return (
    <Box {...props}>
      {showHeading && (
        <Text size="xs" color="dimmed" mb="sm" tt="uppercase">
          {t("SFC Licences")}
        </Text>
      )}
      {SFC_LICENCE_TYPES.map(({ name, labelKey }) => (
        <Group key={name} mb="sm" spacing="sm" noWrap align="flex-start">
          {sfcLicences?.[name] ? (
            <IconCircleCheck color="#00b341" size={18} style={{ flexShrink: 0 }} />
          ) : (
            <IconAlertCircle color="#ff4500" size={18} style={{ flexShrink: 0 }} />
          )}
          <Text size="sm">{t(labelKey)}</Text>
        </Group>
      ))}
    </Box>
  );
};

export default SfcLicenceReadOnlyList;
